import { application } from "../controllers/application";

application.warnings = true;
application.debug = document.documentElement.dataset.env !== "production";

export { application };
